import * as React from 'react'
import { ComponentType } from 'react'
import { NavigationProps, withNavigation } from '@shared/components/navigation'
import { withService } from '@shared/hocs/with-service'
import { Tab, Tabs } from '@shared/components/tabs/tabs'
import {
    holdingsReportsPath,
    planIncentivesPath,
    poolReportsPath,
    poolsPath,
    reportsPath
} from '@logic'

type Props = NavigationProps

let _ReportsHeader: any = null
const ReportsHeaderInner = (props: Props) => {
    const { params } = props

    const links: Tab[] = [
        {
            destination: reportsPath,
            name: 'Holders',
            exact: true,
        },
        {
            destination: poolReportsPath,
            name: 'Pools',
        },
        {
            destination: holdingsReportsPath,
            name: 'Holdings',
        },
    ]

    return <Tabs tabs={links} title={'Reports'} params={params} />
}
// Lazy: defer withService to first render (avoid webpack scope-hoisting TDZ crash)
const ReportsHeader: React.ComponentType<any> = (props: any) => {
    if (!_ReportsHeader) _ReportsHeader = withNavigation(withService(ReportsHeaderInner as any))
    return React.createElement(_ReportsHeader, props)
}

export function withReportsHeader<P>(InnerComponent: ComponentType<P>): ComponentType<P> {
    return (props: any) => (
        <React.Fragment>
            <ReportsHeader {...props} />
            <InnerComponent {...props} />
        </React.Fragment>
    )
}
